import { FC } from "react";

interface VersionDisplayProps {
  className?: string;
  version: string;
}

export const VersionDisplay: FC<VersionDisplayProps> = ({ className = "", version }) => {
  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-gray-100 text-gray-800 border ${className}`}
    >
      {version}
    </span>
  );
};
